import { responseHero } from '../utils/axiosInterceptor';
import { DaisyPayoutRegister } from '../models/daisypayoutregister.model';

export const createDaisyPayoutRegister = async (data: Partial<DaisyPayoutRegister>): Promise<DaisyPayoutRegister> => {
  const response = await responseHero.post(`${process.env.REACT_APP_API_URL}/payoutregister/daisy`, { data: data });
  return response.data;
};